// import 'virtual:svg-icons-register';

import { initHeaderScroll } from './../../src/assets/js/legacy/initHeaderScroll.js';
import { initMobieFilter } from './../../src/assets/js/legacy/initMobieFilter.js';
import { initScrollToTop } from './../../src/assets/js/legacy/initScrollToTop.js';
import { initLanguageSwitcher } from './../../src/assets/js/legacy/initLanguageSwitcher.js';
import { initMobileLanguageSwitcher } from './../../src/assets/js/legacy/initMobileLanguageSwitcher.js';
import { initBurgerMenu } from './../../src/assets/js/legacy/initBurgerMenu.js';
import { initMobileMenuToggle } from './../../src/assets/js/legacy/initMobileMenuToggle.js';
import { initFilterTitleDropdown } from './../../src/assets/js/legacy/initFilterTitleDropdown.js';
import { initSplideSlider } from './../../src/assets/js/legacy/initSplideSlider.js';
import { initMobileSlider } from './../../src/assets/js/legacy/initMobileSlider.js';
import { initAppBannerClose } from './../../src/assets/js/legacy/initAppBannerClose.js';
import { initDropdownMenus } from './../../src/assets/js/legacy/initDropdownMenus.js';
import { initAccordions } from './../../src/assets/js/legacy/initAccordions.js';
import { initFilterSort } from './../../src/assets/js/legacy/initFilterSort.js';
import { initSearchOverlay } from './../../src/assets/js/legacy/initSearchOverlay.js';
import { initSearchFilter } from './../../src/assets/js/legacy/initSearchFilter.js';
import { initSocialShareButtons } from './../../src/assets/js/legacy/initSocialShareButtons.js';
import { initHeaderSearch } from './../../src/assets/js/legacy/initHeaderSearch.js';
import { initYouTubePlaceholders } from '../components/initYouTubePlaceholders.js';
import { initSliderEventsMain } from '../components/initSliderEventsMain.js';
import { toggleText } from '../components/toggleText.js';
import { initCalendar } from './../../src/assets/js/legacy/initCalendar.js';
import { initSubscribeForm } from './../../src/assets/js/legacy/initFormSubscribe.js';
import { initAuthorSort } from '../components/initAuthorSort.js';



import './../../src/assets/scss/legacy/_common.scss';
import './../../src/assets/scss/legacy/style-new.scss';
import './../../src/assets/scss/components/comments.scss'
import './../../src/assets/scss/legacy/post-meta.scss'
import './../../src/assets/scss/components/_live-stream.scss';
import './../../src/assets/scss/components/_platform-updates-card.scss';
import './../../src/assets/scss/components/_main-page-slider-events.scss';
import './../../src/assets/scss/components/_info-modals.scss';
import './../../src/assets/scss/components/_filter-drpdown.scss';
import './../../src/assets/scss/sections/_calendar.scss';
import './../../src/assets/scss/sections/_calendar-single.scss';
import './../../src/assets/scss/sections/_form-blog-page.scss';
import './../../src/assets/scss/sections/_author.scss';
import '../../src/assets/scss/components/_post-page-new.scss';
import '../../src/assets/scss/components/_cta-btns.scss';
import './../../src/assets/scss/sections/_author-archive.scss';
import './../../src/assets/scss/sections/_top-traders.scss';



document.addEventListener('DOMContentLoaded', function () {
  initHeaderScroll();
  initMobieFilter();
  initScrollToTop();
  initLanguageSwitcher();
  initMobileLanguageSwitcher();
  initBurgerMenu();
  initMobileMenuToggle();
  initFilterTitleDropdown();
  initSplideSlider();
  initMobileSlider();
  initAppBannerClose();
  initDropdownMenus();
  initAccordions();
  initFilterSort();
  initSearchOverlay();
  initSearchFilter();
  initSocialShareButtons();
  initYouTubePlaceholders('.live-stream__video-placeholder');
  toggleText();
  initCalendar();
  initSubscribeForm();
  initSliderEventsMain();
  initHeaderSearch();
  initAuthorSort();
  initTopAssets();

  window.addEventListener('resize', () => {
    if (!document.querySelector('.po-intro__mobile-slider')) {
      initMobileSlider();
    }
  });
});

// eslint-disable-next-line no-undef
if (BS_ON === 'true' && NODE_ENV === 'development') {
  const script = document.createElement('script')
  // eslint-disable-next-line no-undef
  script.src = `http://localhost:${BS_PORT}/browser-sync/browser-sync-client.js`
  document.head.appendChild(script)
}
